import * as React from 'react'
import { Heart, ShoppingCart } from 'lucide-react'

import { cn, LocalizedLink } from '@rewardops/ui'

export function ShoppingCartLink({
  cartQuantity,
  className,
}: {
  cartQuantity: number
  className?: string
}) {
  return (
    <LocalizedLink
      id="shopping-cart-link"
      href="/shopping-cart"
      className="relative inline-block hover:text-tenant-primary-color"
      aria-label="shopping-cart"
    >
      <ShoppingCart
        className={cn(
          'h-6 w-6 text-nav-text-color hover:text-tenant-primary-color',
          className,
        )}
      />
      {cartQuantity > 0 && (
        <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] border-white bg-tenant-primary-color text-xs font-semibold text-white">
          {cartQuantity}
        </span>
      )}
    </LocalizedLink>
  )
}

export function HeartLink({
  savedItemsCount,
  className,
}: {
  savedItemsCount: number
  className?: string
}) {
  return (
    <LocalizedLink
      id="wishlist-link"
      href="/wishlist"
      className="relative inline-block hover:text-tenant-primary-color"
      aria-label="wishlist"
    >
      <Heart
        className={cn(
          'h-6 w-6 text-nav-text-color hover:text-tenant-primary-color',
          className,
        )}
      />
      {savedItemsCount > 0 && (
        <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] border-white bg-tenant-primary-color text-xs font-semibold text-white">
          {savedItemsCount}
        </span>
      )}
    </LocalizedLink>
  )
}
